import * as React from 'react';
import { PaymentIntegration, } from '@wix/ambassador-billing-legacy-v1-payment-source/types';
import { PaymentBrand, } from '../../types';
import { PaymentMethodLogo } from '../../components/PaymentMethodLogo/PaymentMethodLogo';
import { paymentBrandName } from '../paymentBrandName';
import { cardBrandToPaymentBrandMapper, isCreditCardBrandMap, } from '../../utils/cardBrandToPaymentBrandMapper';
import { PaymentBrandLogo } from '../..';
export const paymentMethodDisplay = (paymentMethod, locale) => {
    return mapPaymentMethod(paymentMethod, locale);
};
const mapPaymentMethod = (paymentMethod, locale) => {
    if (paymentMethod?.paymentBrand) {
        return mapPaymentMethodAssetsModel(paymentMethod, locale);
    }
    else {
        return mapPaymentMethodBgModel(paymentMethod, locale);
    }
};
const mapPaymentMethodAssetsModel = (paymentMethod, locale) => {
    const { label, paymentBrand } = paymentMethod;
    const paymentBrand_typed = paymentBrand;
    let identifier = label;
    if (paymentBrand_typed === PaymentBrand.SEPA_DIRECT_DEBIT) {
        // I'll remove this line after I'll confirnm the server will return this value
        identifier = `${identifier.split(' ')[0]} ••••-${identifier.split(' ')[1]}`;
    }
    if (isCreditCardBrandMap[paymentBrand_typed]) {
        // I'll remove this line after I'll confirnm the server will return this value
        identifier = `••••${identifier}`;
    }
    if (paymentBrand_typed === PaymentBrand.BOLETO ||
        paymentBrand_typed === PaymentBrand.BANK_TRANSFER) {
        // I'll remove this line after I'll confirnm the server will return this value -> the server does not return label for Boleto/bank transfer, we use the name instead.
        identifier = paymentBrandName(paymentBrand_typed, locale).longName;
    }
    return {
        identifier: identifier,
        brand: paymentBrand_typed,
        logo: React.createElement(PaymentMethodLogo, { cardBrand: paymentBrand_typed }),
        brandLogos: {
            small: React.createElement(PaymentBrandLogo, { size: "small", cardBrand: paymentBrand_typed }),
            large: React.createElement(PaymentBrandLogo, { size: "large", cardBrand: paymentBrand_typed }),
        },
        ...paymentBrandName(paymentBrand_typed, locale),
    };
};
const mapPaymentMethodBgModel = (paymentMethod, locale) => {
    const { publicSepaDetails, publicCreditCard, cashDetails, publicAlternativePaymentMethodDetails, publicDirectDebitDetails, } = paymentMethod;
    if (publicCreditCard) {
        const paymentBrand = cardBrandToPaymentBrandMapper(publicCreditCard.cardBrand);
        return {
            identifier: `••••${publicCreditCard.lastDigits}`,
            brand: paymentBrand,
            logo: React.createElement(PaymentMethodLogo, { cardBrand: paymentBrand }),
            brandLogos: {
                small: React.createElement(PaymentBrandLogo, { size: "small", cardBrand: paymentBrand }),
                large: React.createElement(PaymentBrandLogo, { size: "large", cardBrand: paymentBrand }),
            },
            ...paymentBrandName(paymentBrand, locale),
        };
    }
    const sepaDetails = publicSepaDetails || publicDirectDebitDetails?.sepaDetails;
    if (sepaDetails) {
        return {
            identifier: `${sepaDetails.ibanCountryCode} ••••-${sepaDetails.ibanLastChars}`,
            brand: PaymentBrand.SEPA_DIRECT_DEBIT,
            logo: React.createElement(PaymentMethodLogo, { cardBrand: PaymentBrand.SEPA_DIRECT_DEBIT }),
            brandLogos: {
                small: (React.createElement(PaymentBrandLogo, { size: "small", cardBrand: PaymentBrand.SEPA_DIRECT_DEBIT })),
                large: (React.createElement(PaymentBrandLogo, { size: "large", cardBrand: PaymentBrand.SEPA_DIRECT_DEBIT })),
            },
            ...paymentBrandName(PaymentBrand.SEPA_DIRECT_DEBIT, locale),
        };
    }
    if (cashDetails) {
        return {
            identifier: 'CPF/CNPJ',
            brand: PaymentBrand.BOLETO,
            logo: React.createElement(PaymentMethodLogo, { cardBrand: PaymentBrand.BOLETO }),
            brandLogos: {
                small: (React.createElement(PaymentBrandLogo, { size: "small", cardBrand: PaymentBrand.BOLETO })),
                large: (React.createElement(PaymentBrandLogo, { size: "large", cardBrand: PaymentBrand.BOLETO })),
            },
            ...paymentBrandName(PaymentBrand.BOLETO, locale),
        };
    }
    if (publicAlternativePaymentMethodDetails) {
        const { buyerPaymentMethodName, alternativePaymentMethodType, paymentBrand, paymentIntegration, } = publicAlternativePaymentMethodDetails;
        const isPaymentIntegrationAvailable = paymentIntegration !== PaymentIntegration.NONE;
        const alternativePaymentMethodBrand = (paymentBrand?.brand ??
            (isPaymentIntegrationAvailable
                ? paymentIntegration
                : alternativePaymentMethodType));
        return {
            identifier: buyerPaymentMethodName,
            brand: alternativePaymentMethodBrand,
            logo: React.createElement(PaymentMethodLogo, { cardBrand: alternativePaymentMethodBrand }),
            brandLogos: {
                small: (React.createElement(PaymentBrandLogo, { size: "small", cardBrand: alternativePaymentMethodBrand })),
                large: (React.createElement(PaymentBrandLogo, { size: "large", cardBrand: alternativePaymentMethodBrand })),
            },
            ...paymentBrandName(alternativePaymentMethodBrand, locale),
        };
    }
    return {
        longName: PaymentBrand.UNKNOWN,
        shortName: PaymentBrand.UNKNOWN,
        identifier: '',
        brand: PaymentBrand.UNKNOWN,
        logo: React.createElement(React.Fragment, null),
        brandLogos: {
            small: React.createElement(React.Fragment, null),
            large: React.createElement(React.Fragment, null),
        },
    };
};
//# sourceMappingURL=paymentMethodDisplay.js.map